import React from 'react';
import PurposeLaneCard from '../cards/PurposeLaneCard';
import "../../styles/PurposeSection.css";

export default function PurposeSection() {
  const lanes = [
    { glyph: "📘", title: "Learn", desc: "Master in-demand skills from experts" },
    { glyph: "🚀", title: "Create", desc: "Build your portfolio & personal brand" },
    { glyph: "⚡", title: "Grow", desc: "Expand your reach & unlock opportunities" },
    { glyph: "₹", title: "Earn", desc: "Monetize your skills & live your dream" }
  ];

  return (
    <section className="about-client-purpose-block">
      <div className="about-client-max-width client-purpose-flex">
        
        
        <div className="client-purpose-left-graphics-housing">
          <div className="purpose-image-frame-relative">
            <img 
              src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80" 
              alt="Team Workspace" 
              className="purpose-embedded-photo" 
            />
            
            
            <div className="our-mission-overlay-glass-capsule">
              <div className="mission-card-circles-decor"></div>
              <div className="mission-glass-play-circle">
                <span className="mission-play-triangle">▶</span>
              </div>
              <div className="mission-glass-text-block">
                <strong>Our Mission</strong>
                <p>To empower every creator with the knowledge, skills and confidence to turn their passion into a purpose.</p>
              </div>
            </div>
          </div>
        </div>

        
        <div className="client-purpose-right-text-block">
          <span className="client-uppercase-overline gold-text">OUR PURPOSE</span>
          <h2 className="client-section-title">Why We <span className="blue-inline-span">Exist</span></h2>
          
          
          <div className="purpose-decorative-stroke-line">
            <div className="stroke-line-core"></div>
            <div className="stroke-line-dot-accent"></div>
          </div>

          <p className="client-section-body-text text-slate">
            The creator economy is changing the world. We believe anyone with a smartphone and passion can build a brand, create impact and earn a great living.
          </p>
          <p className="client-section-body-text text-slate strong-margin-spacing">
            Our mission is to democratize quality education and mentorship for aspiring creators across India and beyond.
          </p>
          
          
          <div className="purpose-four-lane-matrix">
            {lanes.map((lane, idx) => (
              <PurposeLaneCard key={idx} {...lane} />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}